import { computed } from 'vue'
import { useUser } from '@gat-ship/user'
import {
  modalTypeLabel,
  parseModalType,
  parseTheme
} from '../model/general-preferences'

/**
 * General-panel preferences seam: the popup-style label plus the modal-type /
 * theme setters. The pure validators gate each write; the shell performs the
 * `updateUserPreferences` call only when a value is returned.
 */
export function useGeneralPreferences() {
  const { userPreferences } = useUser()

  const popupStyleLabel = computed(() =>
    modalTypeLabel(userPreferences.getUserPreferences().modalType)
  )

  function setModalType(value: unknown) {
    const modalType = parseModalType(value)
    if (modalType) userPreferences.updateUserPreferences({ modalType })
  }

  function setTheme(value: unknown) {
    const theme = parseTheme(value)
    if (theme) userPreferences.updateUserPreferences({ theme })
  }

  return { popupStyleLabel, setModalType, setTheme }
}
